import React from "react";
import styled from "styled-components";
import Container from "../../Components/Container";
import Row from "../../Components/Row";
import Vs from "../../assets/images/vs.png";
import NotARobot from "../../assets/images/notARobot.png";

const Title = styled.h1`
  font-weight: 700;
  font-size: 40px;
  color: #e4da1b;
  line-height: 69px;
`;
const SubTitle = styled.p`
  font-weight: 300;
  font-size: 25px;
  color: #ffffff;
  line-height: 30px;
`;

const Info = styled.p`
  font-weight: 300;
  font-size: 20px;
  color: #ffffff;
  line-height: 30px;
  max-width: 750px;
  margin: auto;
`;

const InfoVs = styled.p`
  font-weight: 300;
  font-size: 20px;
  color: #ffffff;
  line-height: 30px;
  max-width: 750px;
`;

const Comparison = () => {
  const isMobile = () => window.innerWidth <= 768;

  return (
    <Container
      style={{
        textAlign: "center",
        paddingBottom: "80px",
        paddingTop: "80px",
        position: "relative",
      }}
      id="section-3"
    >
      {!isMobile() && (
        <img
          style={{ position: "absolute", right: "100px", top: "20px" }}
          src={NotARobot}
          alt="not-a-robot"
        />
      )}
      <Title>
        O Alfred não é um <span style={{ color: "#ffffff" }}>chatbot</span>
      </Title>
      <SubTitle>
        Chatbots seguem roteiros. O{" "}
        <span style={{ fontWeight: 700, color: "#E4DA1B" }}>Alfred</span>{" "}
        entende conversas.
      </SubTitle>
      <Info>
        Enquanto um chatbot tradicional só responde o que foi programado, o
        Alfred usa inteligência artificial real para compreender intenções,
        adaptar respostas e conduzir o cliente até o resultado certo, sem
        parecer um robô.
      </Info>
      <Row
        lg="1fr 1fr 1fr"
        sm="1fr"
        style={{ alignItems: "center", marginTop: "40px" }}
      >
        {!isMobile() && (
          <>
            <Title style={{ color: "#ffffff" }}>Chatbot</Title>
            <img
              alt="vs"
              src={Vs}
              style={{ maxWidth: "80%", margin: "auto" }}
            />
            <Title>Alfred</Title>
          </>
        )}
      </Row>
      <Row lg="1fr 2px 1fr" style={{ borderTop: !isMobile() ? "solid 2px #6125E5" : 'none' }}>
        <div
          style={{
            textAlign: "right",
            height: "100%",
            marginRight: "20px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "flex-end",
          }}
        >
          <InfoVs>Respostas engessadas</InfoVs>
          <InfoVs>Fluxos manuais e limitados</InfoVs>
          <InfoVs>Dificuldade para entender contexto</InfoVs>
          <InfoVs>Depende de palavras exatas para funcionar</InfoVs>
        </div>
        {!isMobile() ? (
          <div
            style={{ height: "350px", width: "2px", background: "#6125E5" }}
          ></div>
        ) : (
          <>
            <div
              style={{ height: "2px", width: "100%", background: "#6125E5" }}
            ></div>
            <Title style={{ color: "#ffffff" }}>Chatbot</Title>
            <img
              alt="vs"
              src={Vs}
              style={{ maxWidth: "80%", margin: "auto" }}
            />
            <Title>Alfred</Title>
            <div
              style={{ height: "2px", width: "100%", background: "#6125E5" }}
            ></div>
          </>
        )}
        <div
          style={{
            textAlign: "left",
            height: "100%",
            marginLeft: "20px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <InfoVs>Conversa de forma natural e inteligente</InfoVs>
          <InfoVs>Aprende com cada interação</InfoVs>
          <InfoVs>Se adapta ao tom da sua marca</InfoVs>
          <InfoVs>
            Conecta-se ao seu sistema e executa ações (agendar, vender,
            responder, etc.)
          </InfoVs>
        </div>
      </Row>
    </Container>
  );
};

export default Comparison;
